/**
 * Consecutivo de actas.
 *
 * Los endpoints que satisface son: consecutive.
 *
 * @export
 * @class ConsecutiveAtc
 */
export class ConsecutiveAtc {
    id?: number;
    consecutivo_inicial: number;
    consecutivo_final: number;
  }


// WEBPACK FOOTER //
// ./src/app/shared/models/consecutive-atc.models.ts